import React from 'react';
import { useSelector } from 'react-redux';

import { Paper, Grid, Typography } from '@material-ui/core';
import Loader from 'components/Loader';

import { WhatsApp } from '@material-ui/icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

export default function Resume() {
  const isResale = !!process.env.REACT_APP_RESALE_ID;

  const { isLoading } = useSelector(state => state.businessInfoRegistration);

  return(
    <Paper style={{ padding: 30, marginBottom: 30 }}>
      <Loader isLoading={isLoading}>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant='h6'>
              <b>Resumo da nova unidade</b>
            </Typography>
          </Grid>
        </Grid>
        <Grid container justify='flex-start' alignItems='center' style={{ gap: 10, padding: 15, marginTop: 20, backgroundColor: '#FFF2DC', border: '2px solid #FFC48A', borderRadius: 8 }}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 50, height: 50, borderRadius: '50%', backgroundColor: 'rgba(231, 116, 18, 0.15)' }}>
            <FontAwesomeIcon
              size='2x'
              color='#E77412'
              icon={faTriangleExclamation}
            />
          </div>
          <div>
            <Typography variant='h5'>
              <b>A nova unidade será criada DESATIVADA</b>
            </Typography>
            <Typography variant='subtitle2' style={{ color: '#893500' }}>
              <b>Após a criação, a unidade só poderá ser utilizada depois da ativação realizada pela equipe financeira.</b>
            </Typography>
          </div>
        </Grid>
        {!isResale && (
          <Grid container direction='column' alignItems='flex-start' style={{ gap: 10, padding: 15, marginTop: 20, border: '2px solid #c4c4c4', borderRadius: 8 }}>
            <Typography variant='subtitle2'>
              Precisa ativar a nova unidade? Fale com nosso financeiro pelo WhatsApp.
            </Typography>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
              <button
                type='button'
                style={{ height: 40, color: '#FFFFFF', backgroundColor: '#43A047', border: 'none', borderTopLeftRadius: 3, borderBottomLeftRadius: 3, padding: 5, cursor: 'pointer' }}
              >
                <WhatsApp />
              </button>
              <button
                type='button'
                onClick={() => {
                  const url = `https://wa.me/+5521999966453/?text=Olá! Quero falar com o financeiro para ativar uma nova unidade.`;
                  return window.open(url, '_blank');
                }}
                style={{ height: 40, color: '#FFFFFF', backgroundColor: '#13BC4B', border: 'none', borderTopRightRadius: 3, borderBottomRightRadius: 3, padding: 5, cursor: 'pointer', textTransform: 'uppercase' }}
              >
                <b>Falar com o financeiro no WhatsApp</b>
              </button>
            </div>
          </Grid>
        )}
      </Loader>
    </Paper>
  );
}